import { Link } from "react-router-dom";
import { Instagram, Facebook, ArrowUpRight } from "lucide-react";
import { SecurePayment } from "./SecurePayment";

const LOGO = "https://customer-assets-cm19k8pv.emergentagent.net/job_harvest-books-9/artifacts/7sqc5jtf_LOGO%20Harvest%20Books%20-%20H%20-%20Blue%20Gradient.webp";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#0a1b33] text-white" data-testid="site-footer">
      <div className="max-w-[1500px] mx-auto px-4 sm:px-6 lg:px-10 pt-20 pb-10">
        <div className="grid lg:grid-cols-[1.5fr_1fr_1fr_1fr] gap-12">
          <div>
            <img src={LOGO} alt="Editorial Harvest" className="h-12 md:h-14 w-auto brightness-0 invert" />
            <p className="font-serif text-2xl font-medium mt-6 max-w-xs leading-tight">Donde comienza la excelencia.</p>
          </div>
          <FootCol title="Explora" links={[["Libros", "/libros"], ["Ebooks", "/ebooks"], ["Libros en tu Iglesia", "/libros-en-tu-iglesia"], ["Distribuidores", "/distribuidores"], ["Autores", "/autores"], ["Gratis", "/gratis"]]} />
          <FootCol title="Harvest" links={[["Nosotros", "/nosotros"], ["Publica", "/publica-con-harvest"], ["Contacto", "/contacto"]]} />
          <FootCol title="Legal" links={[["Aviso legal", "/aviso-legal"], ["Privacidad", "/politica-de-privacidad"], ["Cookies", "/politica-de-cookies"], ["Condiciones de Venta", "/condiciones-de-venta"]]} />
        </div>

        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mt-16 pt-8 border-t border-white/12">
          <div className="text-sm text-white/50 leading-relaxed">
            Harvest Books Ltd. · Rue de Vermont 9A · 1202 Ginebra, Suiza
          </div>
          <SecurePayment />
        </div>
        <div className="mt-8 flex justify-center gap-3" data-testid="footer-social">
          <a href="https://www.facebook.com/editorialharvest" target="_blank" rel="noreferrer" className="p-2.5 border border-white/20 hover:bg-white hover:text-[#0a1b33] transition-colors" data-testid="footer-facebook" aria-label="Facebook"><Facebook size={16} /></a>
          <a href="https://www.instagram.com/editorialharvest/" target="_blank" rel="noreferrer" className="p-2.5 border border-white/20 hover:bg-white hover:text-[#0a1b33] transition-colors" data-testid="footer-instagram" aria-label="Instagram"><Instagram size={16} /></a>
        </div>
        <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-white/35">
          <span>© {year} Harvest Books Ltd. Todos los derechos reservados.</span>
          <div className="flex items-center gap-5">
            <button onClick={() => window.dispatchEvent(new Event("hv:open-cookies"))} className="hv-overline hv-overline-light hover:text-white transition-colors" data-testid="footer-cookie-settings">Configurar cookies</button>
            <Link to="/admin/login" className="hv-overline hv-overline-light hover:text-white transition-colors" data-testid="footer-admin-link">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FootCol({ title, links }) {
  return (
    <div>
      <h4 className="hv-overline hv-overline-light mb-5">{title}</h4>
      <ul className="space-y-3">
        {links.map(([l, to]) => (
          <li key={to}><Link to={to} className="group inline-flex items-center gap-1 text-white/70 hover:text-white transition-colors">{l}<ArrowUpRight size={13} className="opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" /></Link></li>
        ))}
      </ul>
    </div>
  );
}
